import React from 'react';
import { observer } from 'mobx-react-lite';
import { Warning } from '@linktivity/link-icons';

import { useStore } from '@link/china-railway/stores';

import styles from './message.module.css';

const WarningMessages: React.FC = () => {
  const { chinaRailway } = useStore();
  const { warningMessages } = chinaRailway;

  if (!warningMessages.length) {
    return null;
  }

  return (
    <div className={styles.message}>
      <Warning className={styles.messageWarningIcon} />
      <div className={styles.messageContent}>
        {warningMessages.map(m => {
          return (
            <div key={m} className={styles.messageItem}>
              <p className={styles.messageText}>{m}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ObservedWarningMessages = observer(WarningMessages);
export default ObservedWarningMessages;
